@keyframes slide-in {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  @keyframes slide-out {
    from {
      opacity: 1;
      transform: translateY(0);
    }
    to {
      opacity: 0;
      transform: translateY(20px);
    }
  }
  
  .toastAnimate {
    opacity: 0;
    animation: slide-in 0.3s ease-out forwards;
    animation-delay: 0.5s;
  }
  
  .toastSlideOut {
    animation: slide-out 0.3s ease-in forwards;
  }